/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { RowSeparator } from "../../atoms/RowSeparator";
import FirstCollection from "./FirstCollection";
import SecondCollection from "./SecondCollection";
import { DfpComponent } from "../../ads/dfp-component";
import "./four-col-four.m.css";
export default function FourColumnFourStories({ collection = {}, extraProp = "" }) {
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const showColumnSeparator = associatedMetadata.show_column_separator || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const enableRowAd = associatedMetadata.enable_row_ad || null;
  const rowAdDetails = associatedMetadata.row_ad_details || null;
  const rowAdUnitBottom = associatedMetadata.show_row_ad_unit_bottom || null;

  const rowAd = rowAdDetails?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));

  const rowAdBottom = rowAdUnitBottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const filteredCollection = get(collection, ["items"], []).filter((collections) => collections.type === "collection");

  if (filteredCollection.length < 2) return null;

  const collOneStories = get(filteredCollection[0], ["items"], []).filter((item) => item.type === "story");
  const collTwoStories = get(filteredCollection[1], ["items"], []).filter((item) => item.type === "story");

  const sectionSlug = extraProp;
  return (
    (collOneStories.length > 0 || collTwoStories.length > 0) && (
      <div className="row-component" styleName="top-component-wrapper">
        <div styleName={`${showColumnSeparator ? "list-with-seperator" : "four-col-four-list"}`}>
          <div>
            <FirstCollection
              collectionItem={filteredCollection[0]}
              associatedMetadata={associatedMetadata}
              sectionSlug={sectionSlug}
            />
          </div>
          {showColumnSeparator && (collTwoStories.length > 0 || enableRowAd) && <div styleName="coll-divider"></div>}
          <div>
            {enableRowAd ? (
              <DfpComponent adStyleName="four-col-four-ad-slot-size-300x250" id={rowAdDivId} />
            ) : (
              collTwoStories.length > 0 && (
                <SecondCollection
                  collectionItem={filteredCollection[1]}
                  associatedMetadata={associatedMetadata}
                  sectionSlug={sectionSlug}
                />
              )
            )}
          </div>
        </div>
        {showRowSeparator && <RowSeparator />}
        {rowAdUnitBottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
      </div>
    )
  );
}

FourColumnFourStories.propTypes = {
  collection: PropTypes.object.isRequired,
  extraProp: PropTypes.string,
};
